import { addPermissionsToRoute } from '@/myq-core';

const routes = {
  name: 'People',
  icon: 'mdi-account-multiple-outline',
  path: '/reports/people/',
  children: [
    {
      path: '/reports/people/overTimeAudit',
      name: 'Overtime Audit',
      meta: { id: 'reports-overtimeAudit' },
      component: () => import('./OvertimeAudit.vue'),
      ...addPermissionsToRoute(['overtimeAudit']),
    },
  ]
};

export default routes;